import { createFileRoute } from '@tanstack/react-router';

// The Directory tab content is populated in a later PR of the integrations-directory migration.
function IntegrationsDirectoryRoute() {
  return null;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all/directory')({
  component: IntegrationsDirectoryRoute,
});
